import {useApi} from "~/composables/api/utils/useApi"

export const useCourseApi = () => ({
  async requestInformation(requestData) {
    const url = "contacts"
    const api = useApi()

    return api.makeRequest(url, 'post', requestData)
  },

  async loadUserCourses() {
    const url = `me/courses`
    const api = useApi()

    return api.makeRequest(url, 'get')
  },

  async getUserCourse(userCourseId) {
    const url = `me/courses/${userCourseId}`
    const api = useApi()

    return api.makeRequest(url, 'get')
  },

  async addUserCourseBlockProgress(userCourseId, blockId) {
    const url = `me/courses/${userCourseId}/blocks/${blockId}`
    const api = useApi()

    return api.makeRequest(url, 'put')
  },

  async getUserCourseCertificate(userCourseHash) {
    const url = `${process.env.baseAPI}/me/certificates/${userCourseHash}?pdf=true`

    try {
      const response = await fetch(url)
      return await response.blob()
    } catch (err) {
      throw {...err.response?.data, status: err.response?.status}
    }
  }
})
